import { cn, Select, SelectContent, SelectItem, SelectTrigger } from 'component-library';

import { FormControl, FormDescription, FormItem, FormLabel } from '@/components/Form';

import { useControlsContext } from './Form';

export type SelectOption = {
  label: string;
  value: string;
};

type FormSelectProps = {
  formName: string;
  label?: string;
  helper?: string;
  placeholder?: string;
  options: SelectOption[];
  styles?: Record<string, string>;
};

export const FormSelect = ({ formName, label, helper, placeholder, options, styles }: FormSelectProps) => {
  const { setValue, watch } = useControlsContext();

  const selectedValue = watch(formName);

  const handleValueChange = (value: string) => {
    setValue(formName, value);
  };

  return (
    <FormItem className={cn('flex flex-col gap-1 w-full', styles?.root)}>
      {label && <FormLabel className={cn('typography-body2 text-text-secondary', styles?.label)}>{label}</FormLabel>}
      <FormControl>
        <Select value={selectedValue ?? ''} onValueChange={handleValueChange}>
          <SelectTrigger placeholder={placeholder} />
          <SelectContent>
            {options.map((opt) => (
              <SelectItem key={opt.value} value={opt.value} className='truncate w-full'>
                {opt.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormControl>
      {helper && <FormDescription className={cn(styles?.description)}>{helper}</FormDescription>}
    </FormItem>
  );
};
